import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import {
  i18nTranslate,
  isSepaPaymentRecord,
  isTwikeyPaymentName,
  isSepaMandateInProgress,
  capitalizeFirstLetter,
} from 'src/utils'
import { FaCreditCard as CreditCardIcon } from 'react-icons/fa'
import { BsThreeDotsVertical } from 'react-icons/bs'
import {
  Button,
  Image,
  Modal,
  Container,
  Row,
  Col,
  Dropdown,
  ButtonGroup,
} from 'react-bootstrap'
import {
  PaymentIcon,
  PaymentMarketForm,
  ImageComponent,
} from 'src/views/components'
import EditUpdatePaymentModal from './EditUpdatePaymentModal'
import { customerContainer } from 'src/models'
import { dateFormatDeps } from 'src/deps'
import { getSepaIconURL } from 'src/utils/paymentContainerHelper'
import './styles.scss'

@observer
class PaymentCard extends React.Component {
  @observable isEditEnabled = false
  @observable shouldShowConfirmationView = false
  @observable showEditUpdateModal = false
  @observable IdofCardToBeEdited = ''
  @observable showEditSubscriptionModal = false

  toggleEditState = () => {
    this.isEditEnabled = !this.isEditEnabled
  }

  toggleConfirmationView = () => {
    this.shouldShowConfirmationView = !this.shouldShowConfirmationView
  }

  toggleEditUpdateValue = (e, id = 0) => {
    this.showEditUpdateModal = !this.showEditUpdateModal
    this.IdofCardToBeEdited = id
    //canceling the previous payment form
    const cancelButton = document.getElementById(
      'new-payment-cancel-btn-profile'
    )
    if (cancelButton) {
      cancelButton.click()
    }
    // const editButton = document.getElementById(`edit-button-${id}`)
    // if (editButton) {
    //   editButton.blur()
    // }
  }
  toggleEditSubscriptionValue = (e, id = 0) => {
    this.showEditSubscriptionModal = !this.showEditSubscriptionModal
    this.IdofCardToBeEdited = id
  }
  handleDefaultPayment = () => {
    const postData = { isDefault: true }
    customerContainer.updateDefaultPayment({
      postData,
      id: this.props.cardData.id,
    })
  }

  handleRemovePayment = () => {
    this.toggleConfirmationView()
  }

  handleSavePayment = updatedDetail => {
    const { cardFirstName, expiryDate, setToDefaultPayment, ...addressParams } =
      updatedDetail
    const postData = {
      expiryDate,
      cardFirstName,
      isDefault: setToDefaultPayment,
      billingAddress: {
        email: customerContainer.profileResponse.email,
        type: 'billingAddress',
        ...addressParams,
      },
    }
    customerContainer.updatePayment({
      id: this.props.cardData.id,
      postData,
    })
    this.toggleEditState()
  }

  handleDeletePayment = () => {
    let cardDetails = {
      ...this.props.cardData,
      ...this.props.pageDetails,
    }

    customerContainer.deletePayment(cardDetails)
    this.toggleConfirmationView()
  }

  handleDeletePaymentMethod = cardData => {
    const cardNumber = cardData?.accountInfo?.cardNumber || ''
    const cardProvider = cardData?.accountInfo?.provider || ''
    const isSepaPayment = isSepaPaymentRecord(cardData)
    const sepaToken =
      cardData?.accountInfo?.token ||
      cardData?.accountInfo?.iban ||
      cardData?.accountInfo?.IBAN ||
      cardData?.properties?.iban ||
      ''
    const sepaEndingDigits = sepaToken ? sepaToken.slice(-4) : ''

    return (
      <div>
        <div className="delete-msg-wrapper">
          <span>
            {i18nTranslate('payment.deleteMessageStart', 'Delete')}&nbsp;
          </span>
          {isSepaPayment ? (
            <>
              <span>
                {i18nTranslate(
                  'payment.sepaDirectDebitEndingIn',
                  'Sepa Direct Debit ending in '
                )}
              </span>
              <span>{sepaEndingDigits}&nbsp;</span>
            </>
          ) : (
            <>
              <span>{capitalizeFirstLetter(cardProvider)} &nbsp;</span>
              <span>****{cardNumber}&nbsp;</span>
            </>
          )}
          <span>
            {i18nTranslate(
              'payment.deleteMessageEnd',
              'from your saved payments?'
            )}
          </span>
        </div>
        <div className="d-flex justify-content-between">
          <button
            className="btn btn-outline-primary cancel-btn"
            onKeyPress={this.toggleConfirmationView}
            onClick={this.toggleConfirmationView}>
            {i18nTranslate('payment.cancelDelete', 'Cancel')}
          </button>
          <button
            className="btn btn-primary confirm-btn"
            onKeyPress={() => {
              this.handleDeletePayment()
            }}
            onClick={() => {
              this.handleDeletePayment()
            }}>
            {i18nTranslate('payment.confirmDelete', 'Confirm')}
          </button>
        </div>
      </div>
    )
  }

  /**
   * @description if card is expired then update button will render else else button will render.
   * @date 9/28/2023 - 12:31:58 PM
   *
   * @param {*} cardData contains all card related details
   * @param {*} isCardValid flag to check card expired or not
   * @returns {*} edit/update and delete button in MyAccount-> payments page
   */
  renderButton = (cardData, isCardValid, isDeleteOnly = false) => {
    const cardNumber = cardData?.accountInfo?.cardNumber || ''
    const cardProvider = cardData?.accountInfo?.provider || ''
    const endingDigits = cardNumber
      ? cardNumber.substr(cardNumber.length - 4)
      : undefined

    return (
      <div className="button-wrapper wallet-card">
        <ButtonGroup>
          {!isDeleteOnly && (
            <span className="pr-2">
              <Button
                aria-label={`${i18nTranslate(
                  'payment.editBtnText',
                  'Edit button for'
                )} ${cardProvider} ${i18nTranslate(
                  'payment.cardAndCardNumber',
                  'card & card number'
                )} ${endingDigits}`}
                role="button"
                tabIndex={0}
                className="btn-link d-inline px-2"
                id={`edit-button-${cardData?.id}`}
                onClick={e => this.toggleEditUpdateValue(e, cardData?.id)}
                data-testid={
                  isCardValid ? 'qa-edit-button' : 'qa-update-button'
                }>
                <span aria-hidden="true">
                  {isCardValid
                    ? i18nTranslate('edit', 'Edit')
                    : i18nTranslate('catalog.Update', 'Update', {
                        nameSpace: 'ssr-resource',
                      })}
                </span>
              </Button>
            </span>
          )}
          <span>
            <Button
              aria-label={`${i18nTranslate(
                'payment.removeBtnText',
                'Delete button for'
              )} ${cardProvider} ${i18nTranslate(
                'payment.cardAndCardNumber',
                'card & card number'
              )} ${endingDigits}`}
              role="button"
              tabIndex={0}
              className="btn-link btn-secondary d-inline px-2"
              onClick={this.handleRemovePayment}
              data-testid="qa-delete-button">
              <span aria-hidden="true">
                {i18nTranslate('cart.delete', 'Delete')}
              </span>
            </Button>
          </span>
        </ButtonGroup>
      </div>
    )
  }

  renderCardIcon = icon => {
    if (icon) {
      return (
        <Image
          src={icon}
          className="icon mr-2 mt-1 rounded"
          data-testid="qa-card-logo"
          alt={i18nTranslate('payment.cardIcon', 'Card logo')}
        />
      )
    } else {
      return (
        <CreditCardIcon
          className="icon mr-2 mt-1 rounded"
          aria-label={i18nTranslate('payment.cardIcon', 'Card logo')}
        />
      )
    }
  }

  renderCardDetail = cardData => {
    const cardNumber = cardData?.accountInfo?.cardNumber || ''
    const name = {
      firstName: cardData?.accountInfo?.name || '',
      lastName: cardData?.accountInfo?.lastName || '',
    }
    /**
     * @todo need to add further card type
     */
    const iconType = (cardData?.accountInfo?.provider || '').toLowerCase()
    const endingDigits = cardNumber
      ? cardNumber.substr(cardNumber.length - 4)
      : undefined
    const endingText = i18nTranslate('payment.cardEndingText', 'card ending in')
    const expiryText = i18nTranslate('payment.cardExpiresText', 'Expires')
    const expiredText = i18nTranslate(
      'payment.cardExpiredText',
      'Card is Expired'
    )
    const currentDateTimeStamp = Date.now()
    const { month, year } =
      dateFormatDeps.convertTimeStampToDate(currentDateTimeStamp)

    const getCardExpiredStatus = () => {
      return (
        year < cardData?.accountInfo?.expiryYear ||
        (year == cardData?.accountInfo?.expiryYear &&
          month <= cardData?.accountInfo?.expiryMonth)
      )
    }

    const isCardValid = getCardExpiredStatus()
    const expryTxt = isCardValid ? expiryText : expiredText
    const cardProvider = cardData?.accountInfo?.provider || ''
    const isDefault = cardData?.accountInfo?.isDefault || false

    return (
      <div>
        <div
          className={`card bg-gradient text-white shadow-lg rounded-3 p-2 mb-sm-2 pg-lg-0${isDefault ? ' default-payment' : ''}`}
          style={{ position: 'relative' }}>
          <div className="card-body">
            {isDefault && (
              <span className="badge badge-pill badge-primary default-badge">
                {i18nTranslate('payment.defaultTitle', 'Default Payment')}
              </span>
            )}

            <h3 className="fs-4 fw-bold text-uppercase">
              <PaymentIcon type={iconType} />
              &nbsp;
              {cardProvider}
            </h3>
            <p className="fs-3 fw-bold my-4">**** **** **** {endingDigits}</p>
            <div className="d-flex justify-content-between">
              <div>
                <p className="text-uppercase mb-1 small">
                  {i18nTranslate('payment.cardHolder', 'Card Holder')}
                </p>
                <p className="fs-5">{`${name?.firstName?.toUpperCase()} ${
                  name?.firstName?.toUpperCase() !==
                  name?.lastName?.toUpperCase()
                    ? name?.lastName?.toUpperCase()
                    : ''
                }`}</p>
              </div>
              <div data-testid="qa-expirydate">
                <p className="text-uppercase mb-1 small">
                  {i18nTranslate('payment.expiry', 'Expiry')}
                </p>
                <p className="fs-5">{`${cardData?.accountInfo?.expiryMonth}/${cardData?.accountInfo?.expiryYear?.substr(2)}`}</p>
              </div>
            </div>
            <div className="mt-auto pt-4">
              {/* <p className="text-uppercase mb-1 small">CVV</p>
                  <p className="fs-5">***</p> */}
              {this.renderButton(cardData, isCardValid)}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderSepaDetail = cardData => {
    const iBanValue = cardData?.accountInfo?.token || ''
    const maskedIban = iBanValue ? `${iBanValue.slice(-4)}` : ''
    const isDefault = cardData?.accountInfo?.isDefault || false
    const sepaIconURL = getSepaIconURL()
    const isMandateInProgress = isSepaMandateInProgress(cardData)

    return (
      <div>
        <div
          className={`card bg-gradient text-white shadow-lg rounded-3 p-2 mb-sm-2 pg-lg-0${isDefault ? ' default-payment' : ''}`}
          style={{ position: 'relative' }}>
          <div className="card-body text-left">
            {isDefault && (
              <span className="badge badge-pill badge-primary default-badge">
                {i18nTranslate('payment.defaultTitle', 'Default Payment')}
              </span>
            )}
            <h3 className="fs-4 fw-bold text-uppercase text-left">
              {sepaIconURL ? (
                <ImageComponent
                  testId="qa-sepa-wallet-icon"
                  src={sepaIconURL}
                  name="SEPA"
                  width="40px"
                  height="25px"
                  title="SEPA"
                  aria-label="SEPA-icon"
                  className="payment-icons"
                  customParentClassName="mr-1 mb-1"
                  overrideParentClass={true}
                />
              ) : (
                <PaymentIcon type="sepa" />
              )}
              &nbsp;
              {i18nTranslate(
                'payment.sepaDirectDebitEndingIn',
                'SEPA Direct Debit ending in'
              )}
              &nbsp;
              {maskedIban}
            </h3>
            {!isMandateInProgress && (
              <div className="mt-auto pt-4">
                {this.renderButton(cardData, true, true)}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  isCardShapedPayment = cardData => {
    const {
      cardNumber = '',
      expiryMonth = '',
      expiryYear = '',
    } = cardData?.accountInfo || {}
    return Boolean(cardNumber && expiryMonth && expiryYear)
  }

  getPaymentCardContent = () => {
    const { cardData } = this.props
    if (isTwikeyPaymentName(cardData?.name)) {
      return this.renderSepaDetail(cardData)
    }
    if (cardData?.type === 'CREDITCARD' || cardData?.type === 'DEBITCARD') {
      return this.renderCardDetail(cardData)
    }
    // GPS covers card and non-card processors, so only card-shaped records get the card UI.
    if (cardData?.type === 'GPS' && this.isCardShapedPayment(cardData)) {
      return this.renderCardDetail(cardData)
    }
    return this.renderAlternatepaymentDetail(cardData)
  }

  renderAlternatepaymentDetail = cardData => {
    const buttonStyles = {
      justifyContent: this.shouldShowConfirmationView
        ? 'flex-end'
        : 'space-between',
    }
    return (
      <div>
        <div className="d-flex paymentType-block">
          <PaymentIcon type={cardData?.type?.toLowerCase()} />
          <p className="paymentType-block-texts ml-2">
            {cardData?.type === 'ALIPAY' &&
              i18nTranslate('checkout.alipayText', 'AliPay')}
            {cardData?.type === 'PAYPAL' &&
              i18nTranslate('checkout.paypalText', 'PayPal')}
          </p>
        </div>
        <div className="button-wrapper" style={buttonStyles}>
          {this.renderButton(cardData)}
        </div>
      </div>
    )
  }

  render() {
    const { cardData, index } = this.props
    const isDefault = cardData?.accountInfo?.isDefault || false
    return (
      <div className="payment-card-wrapper" data-testid="qa-payment-container">
        {/* {isDefault && (
          <span className="text-success ml-2">
            {i18nTranslate('payment.defaultTitle', 'Default Payment')}
          </span>
        )} */}
        <div className="payment-card-container">
          {this.isEditEnabled ? (
            <PaymentMarketForm
              index={index}
              paymentData={cardData}
              isFromPayment={true}
              isFromEditPayment={true}
              includePaymetricCvv={false}
              onSubmitForm={this.handleSavePayment}
              onCancel={this.toggleEditState}
              billingAddressType="paymentsMethod"
            />
          ) : (
            this.getPaymentCardContent()
          )}
        </div>
        {/* {this.showEditSubscriptionModal  && (
          <EditSubscriptionPayment
            toggleEditSubscriptionValue={this.toggleEditSubscriptionValue}
            IDofCardToBeEdited={this.IdofCardToBeEdited}
            closeModalCallback={() => {
              this.showEditSubscriptionModal = false
            }}
            billingAddressType="paymentsMethod"
          />
        )} */}
        {/** my account payment cards edit/ update modal */}
        {this.showEditUpdateModal && (
          <EditUpdatePaymentModal
            show={this.showEditUpdateModal}
            closeButton={this.toggleEditUpdateValue}
            billingAddressType="paymentsMethod"
            IDofCardToBeEdited={this.IdofCardToBeEdited}
            isFromCheckout={false}
            cardDetails={cardData}
            closeModalCallback={() => {
              this.showEditUpdateModal = false
            }}
          />
        )}
        {/** my account payment cards delete modal */}
        {this.shouldShowConfirmationView && (
          <div>
            <Modal
              className={`visible modal-wrapper p-0`}
              show={this.shouldShowConfirmationView}
              onHide={() => (this.shouldShowConfirmationView = false)}
              centered
              animation={false}>
              <Modal.Header
                closeButton={this.toggleConfirmationView}
                className={'border-bottom-0'}>
                <Modal.Title className="title-Payment-Modal">
                  {i18nTranslate('checkout.deletePayment', 'Delete Payment')}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.handleDeletePaymentMethod(cardData)}
              </Modal.Body>
            </Modal>
          </div>
        )}
      </div>
    )
  }
}

export { PaymentCard }
export default PaymentCard
